import React from 'react';
import moment from 'moment';
import { observer } from 'mobx-react';

// assets

// services

// props
import { IVesselRequisitionResourceShortProps } from '../../../../../props/vessels/requisitions/requisition';

// components
import { Stack } from '@fluentui/react';
import Details from '../../../../typography/details';

interface VesselRequisitionDetailPropertiesProps {
    requisition: IVesselRequisitionResourceShortProps;
}

const VesselRequisitionDetailProperties: React.FC<VesselRequisitionDetailPropertiesProps> = observer((props: VesselRequisitionDetailPropertiesProps) => {
    const { requisition } = props;

    return <Stack tokens={{ childrenGap: 20 }}>
        <Details title={'Name'} text={requisition.name} />
        <Details title={'Vessel'} text={requisition.vessel.name} />
        <Details title={'Notes'} text={requisition.notes || "-"} />
        <Details title={'Requested by'} text={requisition.createdBy.name + " at " + moment(requisition.createdAt).format("DD/MM/YYYY HH:mm")} />
    </Stack>;
});

export default VesselRequisitionDetailProperties;
